import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import { parseStrapiContent } from "@lib/strapi/content";

export interface StrapiPostDetailSectionDTO
  extends StrapiDynamicZoneComponentDTO {
  showAuthor: boolean;
  showPublishedDate: boolean;
  showRelated: boolean;
}

export class PostDetailSectionDTO extends DynamicZoneComponentDTO {
  constructor() {
    super();
  }

  showAuthor: boolean;
  showPublishedDate: boolean;
  showRelated: boolean;
}
